// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-data-rec-dec {
  grid-column-start: 1;
  grid-column-end: 6;
  border-bottom: 1px solid #d8d9ea;
}
.change-property-decision-warn {
  background-color: white;
  border: 1px solid;
  padding: 20px;
  position: fixed;
  top: 45%;
  left: 51%;
  transform: translate(-50%, -50%);
  z-index: 500;
}
div.modal-overlay-decision-warn {
  background-color: rgba(0, 0, 0, 0.6);
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 50;
}
.hard-decline-trigger-text {
  font-weight: 600;
  color: #dc3545;
  margin: 0 20px;
  font-size: 17px;
  display: inline-block;
  text-decoration: underline;
}
p.rec-dec-label {
  display: inline-block;
  font-size: 17px;
  font-weight: 500;
  padding: 0 6px;
}
.add-decline-button {
  color: #dc3545;
  margin-top: -5px;
  font-size: 25px !important;
}
.hard-decline-trigger-text {
  padding: 20px 0px;
  grid-column-start: 1;
  grid-column-end: 6;
  text-align: center;
}
.decline-reason-control {
  width: 100%;
}
.riq-display {
  float: right;
  font-weight: bolder;
  margin-right: 5px;
  padding-right: 9px;
  border-right: 1px solid;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared-components-module/property-decision-mgr/property-decision-mgr.component.less"],"names":[],"mappings":"AAEA;EACI,oBAAA;EACA,kBAAA;EACA,gCAAA;AADJ;AAIA;EACI,uBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;AAFJ;AAKA;EACI,oCAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;AAHJ;AAMA;EACI,gBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;EACA,0BAAA;AAJJ;AAOA;EACI,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AALJ;AAQA;EACI,cAAA;EACA,gBAAA;EACA,0BAAA;AANJ;AASA;EACI,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;AAPJ;AAUA;EACI,WAAA;AARJ;AAWA;EACI,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;AATJ","sourcesContent":["@import (reference) '../../../styles.less';\n\n.table-data-rec-dec{\n    grid-column-start: 1;\n    grid-column-end: 6;\n    border-bottom: 1px solid #d8d9ea;\n}\n\n.change-property-decision-warn{\n    background-color: white;\n    border: 1px solid;\n    padding : 20px;\n    position: fixed;\n    top: 45%;\n    left: 51%;\n    transform: translate(-50%, -50%);\n    z-index: 500;\n}\n\ndiv.modal-overlay-decision-warn{\n    background-color: rgba(0,0,0,.6);\n    height: 100%;\n    width: 100%;\n    position: fixed;\n    top:0;\n    left:0;\n    z-index: 50;\n}\n\n.hard-decline-trigger-text{\n    font-weight: 600;\n    color: #dc3545;\n    margin: 0 20px;\n    font-size: 17px;\n    display: inline-block;\n    text-decoration: underline;\n}\n\np.rec-dec-label{\n    display: inline-block;\n    font-size: 17px;\n    font-weight: 500;\n    padding: 0 6px;\n}\n\n.add-decline-button{\n    color: #dc3545;\n    margin-top: -5px;\n    font-size: 25px !important;\n}\n\n.hard-decline-trigger-text{\n    padding: 20px 0px;\n    grid-column-start: 1;\n    grid-column-end: 6;\n    text-align: center;\n}\n\n.decline-reason-control{\n    width: 100%;\n}\n\n.riq-display{\n    float:right;\n    font-weight: bolder;\n    margin-right:5px;\n    padding-right: 9px;\n    border-right: 1px solid;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
